// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3GLrq","item":"PaymentsMobile_item__S1TpA","label":"PaymentsMobile_label__34XId","amount":"PaymentsMobile_amount__2VHK9"};